import React from 'react';
import Carousel from './Carousel';
import Autoplay from 'embla-carousel-autoplay';
import { AutoPlayCarouselProps } from 'types/sharedComponents';

const AutoPlayCarousel = ({ plugins, playOnInit, delay, ...props }: AutoPlayCarouselProps) => {
  return <Carousel plugins={[Autoplay({ playOnInit: playOnInit, delay: delay }), ...(plugins ?? [])]} {...props} />;
};

export default AutoPlayCarousel;
